/* Judge.me review widget, product pages: add "Read more" to review text clamped by assets/mm-jdgm.css.
   Judge.me renders (and re-renders on pagination/sort) after load, so new reviews are picked up as they appear. */
(() => {
  const mark = () => document.querySelectorAll('.jdgm-rev-widg .jdgm-rev__body:not([data-mm-clamp])').forEach((b) => {
    if (!b.clientHeight) return; // not laid out yet; try again on the next change
    b.dataset.mmClamp = '';
    if (b.scrollHeight <= b.clientHeight + 2) return;
    const btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'mm-jdgm-more'; btn.textContent = 'Read more'; btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', () => {
      const open = b.classList.toggle('is-open');
      btn.textContent = open ? 'Show less' : 'Read more';
      btn.setAttribute('aria-expanded', String(open));
    });
    b.after(btn);
  });
  let queued = false;
  const queue = () => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; mark(); }); };
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
  addEventListener('load', queue);
  queue();
})();
